export const TaaliaEvent = {
  appLoad: "c.app_load",
  // error: "c.error",
  log: "c.log",
  queueStats: "c.queue_stats",
  selectionIntent: "c.selection_intent",
  turnstileFailed: "c.turnstile_failed",
  turnstileSuccess: "c.turnstile_success",
  turnstileEnteredInteractive: "c.turnstile_entered_interactive",
  turnstileAfterInteractiveCallback: "c.turnstile_after_interactive_callback",
  turnstileDisplayed: "c.turnstile_displayed",
  chatWidgetLoadStart: "c.chat_widget.load.start",
  chatWidgetLoadEnd: "c.chat_widget.load.end",
  appStoreBadgeClicked: "c.app_store_badge_clicked",
  activityReportOpened: "fw.activity.report_view_open",
  openInBrowserDisplayed: "c.open_in_browser_displayed",
  // openInBrowserClicked: "c.open_in_browser_clicked",
  embeddedInWebview: "c.embedded_in_webview",
  logout: "c.logout",
  welcomeMessage: "c.render_welcome_message",
};
